import { 
  FileUploadStatus, 
  // PdfDocument 
} from "entities/UIModel";
import { 
  ErrorCode, 
  FileError 
} from "react-dropzone";

const mapFileUploaResponse = (data: any) => {
  let fileUploadStatuses: FileUploadStatus[] = [];
  fileUploadStatuses = data?.map((d: any) => {
    const fileUploadStatus: FileUploadStatus = {
      documentId: d.DocumentId,
      documentIndex: d.DocumentIndex,
      documentOriginalFileName: d.DocumentOriginalFileName,
      errorMessage: d.ErrorMessage,
      isUploadSuccess: d.IsUploadSuccess,
      documentPath :d.DocumentPath,
      documentDisplayFileName : d.DocumentDisplayFileName,
    };
    return fileUploadStatus;
  });

  return fileUploadStatuses;
};

const getFormattedErrorMessage = (errors: FileError[]) => {
  let errorMessage = "Unexpected error";
  // only use 1st error message in case there are more than errors in a file
  if (errors && errors.length > 0) {
    //errors?.forEach((error) => {
    const error = errors[0];
    switch (error.code) {
      case ErrorCode.FileInvalidType:
        errorMessage = "This format is unsupported";
        break;
      case ErrorCode.FileTooLarge:
        errorMessage = error.message;
        break;
      case ErrorCode.FileTooSmall:
        errorMessage = error.message;
        break;
    }
    // })
  }

  return errorMessage;
}

export {
  mapFileUploaResponse,
  getFormattedErrorMessage,
}